// extracted by mini-css-extract-plugin
module.exports =  {"popper":"_33974c2b58--popper--KAN9G"};